(function( $ ) { //alert("aaaa");
   "use strict";
   var body = $('body'),
       $document = $(document),
      page_type = T4Srequest.page_type,
      cartTypeIsDisable = (T4Sconfigs.cartType == 'disable'),
      strCartDataMini = cartTypeIsDisable ? 'cart_data' : 'cart_data,mini_cart',
      sections_nt = (page_type != 'cart') ? strCartDataMini : `cart_data,${window.cartT4SectionID}`, 
      sections_ntArray = (sections_nt).split(',');

   body.on('click', 'button.single_add_to_cart_buttn', function(e){
        e.preventDefault();
        $('.cl-cart-validate').click();
        $(".cl-po--popup-close").css("display","none");
        $(this).addClass('is--loading');
        
        _learnq.push(['track', 'Added to Cart', item]); // for Klaviyo
        //var formid = $('#cart-form_ppr');
      var formId = $(".t4s-form__product");
     findProgress(formId);
    });

    $(document).on('click', '.mfp-close, .t4s-painting-popup-close', function() {
        $('.t4s-personalization-popup-wrapper, .t4s-personalization-popup')
            .removeClass('mfp-ready')
            .addClass('mfp-hide');
    });
  
    function findProgress(formID){
      let progress_interval = setInterval(function(){
          console.log("checking for progress");
          if($('.options-atc .cl-po--preview-progress').length <= 0){
            var window_url = window.location.pathname;
            if(!window_url.includes('gift-set')){
              $('.cl-cart-validate').click();
              setTimeout(() => {
                addItemFrom(formID);
              }, 1000);
              setTimeout(() => {
                addChargeProduct();
              }, 1200);
              setTimeout(() => {
                 $(".cl-po--popup-close").css("display","block");
                $('.cl-po--popup-close').trigger('click');
                $('button.single_add_to_cart_buttn').removeClass('is--loading');
                $('body').removeClass('no-scrolling');
              }, 2000);
            }
            console.log('no progressbar - add products');
            
            clearInterval(progress_interval);
          }
        }, 500);
    }

    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    function serializet4(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
       return arr;
      //return arr.join('&');
    };

   function addItemFrom(form_id) {
      var  cartAddUrl = T4Sroutes.cart_add_url + '.js';

     var data = serializet4(form_id[0]);
     const personalizationType = $('.cl-po--option')
          .find('input[name="properties[personalization_type]"]:checked')
          .val() || '';
    console.log(personalizationType)
     data.push(
          encodeURIComponent('sections') + '=' + encodeURIComponent(sections_ntArray)
      );
     data.push(
          encodeURIComponent('sections_url') + '=' + encodeURIComponent(window.location.pathname)
      );
     
      fetch(cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            //body: serializet4(form_id[0])
           body: data.join('&')
      })
     .then(function(response) {
          return response.json();
      })
     .then(function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.description);
                 $document.trigger('cart:updated');
                 return;
              }
          $document.trigger('add:cart:success').trigger('add:cart:upsell');
          T4SThemeSP.isATCSuccess = true;
          T4SThemeSP.Cart.renderContents(response.sections);
          if (personalizationType === "Painting") {
              $('.t4s-personalization-popup-wrapper, .t4s-personalization-popup')
                  .removeClass('mfp-hide')
                  .addClass('mfp-ready');
          }
     })
     .catch(function(error) {
        $document.trigger('cart:updated');
        console.log(error);
     });
   } 
    function handleErrorMessage(message) {
      $("button.single_add_to_cart_button").after(
        `<p class="cart-error">${message}</p>`
      );
    }
    //Custom start by chintan
    function addChargeProduct(){
      var iphone_engrave_text = '';

      // Get values
      var engraveMain = $('.cl-po--option').find('[name="properties[iPhone Engrave]"]').val()?.trim();
      var engraveTop = $('.cl-po--option').find('[name="properties[iPhone Engrave Top]"]').val()?.trim();
      let iphone_engrave_top_left = $('.cl-po--option').find('[name="properties[iPhone Engrave Top Left]"]').val() || '';
      let iphone_engrave_top_right = $('.cl-po--option').find('[name="properties[iPhone Engrave Top Right]"]').val() || '';
      let iphone_engrave_bottom_left = $('.cl-po--option').find('[name="properties[iPhone Engrave Bottom Left]"]').val() || '';
      let iphone_engrave_bottom_right = $('.cl-po--option').find('[name="properties[iPhone Engrave Bottom Right]"]').val() || '';
      let iphone_engrave_bottom = $('.cl-po--option').find('[name="properties[iPhone Engrave Bottom]"]').val() || '';
      let iphone_engrave_center = $('.cl-po--option').find('[name="properties[iPhone Engrave Center]"]').val() || '';
      let iphone_engrave_center_left = $('.cl-po--option').find('[name="properties[iPhone Engrave Center Left]"]').val() || '';
      
      // Check if only main/top exist, then treat as string
      if (engraveMain) {
        iphone_engrave_text = engraveMain;
      } 
      // else if (engraveTop) {
      //   iphone_engrave_text = engraveTop;
      // } 
      else {
        // Otherwise, build an array from the rest
        iphone_engrave_text = [];
      
        var otherFields = [
          'iPhone Engrave Top Left',
          'iPhone Engrave Top Right',
          'iPhone Engrave Bottom Left',
          'iPhone Engrave Bottom Right',
          'iPhone Engrave Top',
          'iPhone Engrave Center',
          'iPhone Engrave Bottom',
          'iPhone Engrave Center Left'
        ];
      
        otherFields.forEach(function(field) {
          var value = $('.cl-po--option').find('[name="properties[' + field + ']"]').val();
          if (value && value.trim() !== '') {
            iphone_engrave_text.push(value.trim());
          }
        });
      
        // If none found, make it an empty string
        if (iphone_engrave_text.length === 0) {
          iphone_engrave_text = '';
        }
      }

      var airpods_engrave_text = ($('.cl-po--option').find('[name="properties[Airpods Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Airpods Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Airpods Engrave]"]').val() : '';
      var cardholder_engrave_text = ($('.cl-po--option').find('[name="properties[Cardholder Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Cardholder Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Cardholder Engrave]"]').val() : '';

      let wallet_engrave_text = '';

      let wallet_center = $('.cl-po--option').find('[name="properties[Wallet Engrave Center]"]').val();
      let wallet_top = $('.cl-po--option').find('[name="properties[Wallet Engrave Top]"]').val();
      let wallet_bottom = $('.cl-po--option').find('[name="properties[Wallet Engrave Bottom]"]').val();
      let wallet_inside = $('.cl-po--option').find('[name="properties[Wallet Engrave]"]').val();
      
      // If inside is provided, treat as string
      if (wallet_inside && wallet_inside.trim() !== '') {
        wallet_engrave_text = wallet_inside.trim();
      } else {
        // Else make array from other positions
        wallet_engrave_text = [
          wallet_center,
          wallet_top,
          wallet_bottom
        ].filter(function (val) {
          return val && val.trim() !== '';
        }).map(function (val) {
          return val.trim();
        });
      
        // If no valid entries, fallback to empty string
        if (wallet_engrave_text.length === 0) {
          wallet_engrave_text = '';
        }
      }
    
      var lanyard_engrave_text = [];

      var main = $('.cl-po--option').find('[name="properties[Lanyard Engrave Center]"]').val();
      var top = $('.cl-po--option').find('[name="properties[Lanyard Engrave Top]"]').val();
      var bottom = $('.cl-po--option').find('[name="properties[Lanyard Engrave Bottom]"]').val();
      
      if (main && main.trim() !== '') lanyard_engrave_text.push(main.trim());
      if (top && top.trim() !== '') lanyard_engrave_text.push(top.trim());
      if (bottom && bottom.trim() !== '') lanyard_engrave_text.push(bottom.trim());

      var lanyard_engrave_text = [
        $('.cl-po--option').find('[name="properties[Lanyard Engrave Center]"]').val(),
        $('.cl-po--option').find('[name="properties[Lanyard Engrave Top]"]').val(),
        $('.cl-po--option').find('[name="properties[Lanyard Engrave Bottom]"]').val()
      ].filter(function(val) {
        return val && val.trim() !== '';
      });

      var watch_engrave_text = ($('.cl-po--option').find('[name="properties[Watch Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Watch Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Watch Engrave]"]').val() : '';

      let passport_engrave_text = '';

      let passport_center = $('.cl-po--option').find('[name="properties[Passport Engrave Center]"]').val();
      let passport_top = $('.cl-po--option').find('[name="properties[Passport Engrave Top]"]').val();
      let passport_bottom = $('.cl-po--option').find('[name="properties[Passport Engrave Bottom]"]').val();
      let passport_inside = $('.cl-po--option').find('[name="properties[Passport Engrave]"]').val();
      
      // If inside is provided, treat as string
      if (passport_inside && passport_inside.trim() !== '') {
        passport_engrave_text = passport_inside.trim();
      } else {
        // Else make array from other positions
        passport_engrave_text = [
          passport_center,
          passport_top,
          passport_bottom
        ].filter(function (val) {
          return val && val.trim() !== '';
        }).map(function (val) {
          return val.trim();
        });
      
        // If no valid entries, fallback to empty string
        if (passport_engrave_text.length === 0) {
          passport_engrave_text = '';
        }
      }
      
      var keychain_engrave_text = ($('.cl-po--option').find('[name="properties[Keychain Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Keychain Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Keychain Engrave]"]').val() : '';
      var laptop_engrave_text = ($('.cl-po--option').find('[name="properties[Laptop Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Laptop Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Laptop Engrave]"]').val() : '';
      var lady_pouch_engrave_text = ($('.cl-po--option').find('[name="properties[Lady Pouch Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Lady Pouch Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Lady Pouch Engrave]"]').val() : '';
      var men_pouch_engrave_text = ($('.cl-po--option').find('[name="properties[Men Pouch Engrave]"]').val() != '' && $('.cl-po--option').find('[name="properties[Men Pouch Engrave]"]').length ) ? $('.cl-po--option').find('[name="properties[Men Pouch Engrave]"]').val() : '';

      //painting text
      // var iphone_custom_text = ($('.cl-po--option').find('[name="properties[iPhone Custom Text]"]').val() != '' && $('.cl-po--option').find('[name="properties[iPhone Custom Text]"]').length ) ? $('.cl-po--option').find('[name="properties[iPhone Custom Text]"]').val() : '';
      var airpods_custom_text = ($('.cl-po--option').find('[name="properties[Airpods Custom Text]"]').val() != '' && $('.cl-po--option').find('[name="properties[Airpods Custom Text]"]').length ) ? $('.cl-po--option').find('[name="properties[Airpods Custom Text]"]').val() : '';
      var watch_custom_text = ($('.cl-po--option').find('[name="properties[Watch Custom Text]"]').val() != '' && $('.cl-po--option').find('[name="properties[Watch Custom Text]"]').length ) ? $('.cl-po--option').find('[name="properties[Watch Custom Text]"]').val() : '';
      var keychain_custom_text = ($('.cl-po--option').find('[name="properties[Keychain Custom Text]"]').val() != '' && $('.cl-po--option').find('[name="properties[Keychain Custom Text]"]').length ) ? $('.cl-po--option').find('[name="properties[Keychain Custom Text]"]').val() : '';
    
      //images / logos
      var iphone_image = ($('.cl-po--upload').find('[name="properties[iPhone Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[iPhone Image]"]').length) ? $('.cl-po--upload').find('[name="properties[iPhone Image]"]').val() : '';
      var iphone_image_character = ($('.cl-po--option').find('[name="properties[iPhone Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[iPhone Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[iPhone Image Character]"]').val() : '';
      var iphone_logo = ($('input[name="properties[iPhone Logo]"]:checked').val() != '' && $('input[name="properties[iPhone Logo]"]:checked').length) ? $('input[name="properties[iPhone Logo]"]:checked').val() : '';
      var lanyard_logo = ($('input[name="properties[Lanyard Logo]"]:checked').val() != '' && $('input[name="properties[Lanyard Logo]"]:checked').length) ? $('input[name="properties[Lanyard Logo]"]:checked').val() : '';
      var lanyard_image = ($('.cl-po--upload').find('[name="properties[Lanyard Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Lanyard Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Lanyard Image]"]').val() : '';
      var lanyard_image_character = ($('.cl-po--option').find('[name="properties[Lanyard Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Lanyard Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Lanyard Image Character]"]').val() : '';
      var cardholder_image = ($('.cl-po--upload').find('[name="properties[Cardholder Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Cardholder Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Cardholder Image]"]').val() : '';
      var cardholder_image_character = ($('.cl-po--option').find('[name="properties[Cardholder Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Cardholder Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Cardholder Image Character]"]').val() : '';
      var cardholder_logo = ($('input[name="properties[Cardholder Logo]"]:checked').val() != '' && $('input[name="properties[Cardholder Logo]"]:checked').length) ? $('input[name="properties[Cardholder Logo]"]:checked').val() : '';
      var wallet_image = ($('.cl-po--upload').find('[name="properties[Wallet Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Wallet Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Wallet Image]"]').val() : '';
      var wallet_image_character = ($('.cl-po--option').find('[name="properties[Wallet Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Wallet Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Wallet Image Character]"]').val() : '';
      var wallet_logo = ($('input[name="properties[Wallet Logo]"]:checked').val() != '' && $('input[name="properties[Wallet Logo]"]:checked').length) ? $('input[name="properties[Wallet Logo]"]:checked').val() : '';
      var passport_image = ($('.cl-po--upload').find('[name="properties[Passport Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Passport Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Passport Image]"]').val() : '';
      var passport_image_character = ($('.cl-po--option').find('[name="properties[Passport Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Passport Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Passport Image Character]"]').val() : '';
      var passport_logo = ($('input[name="properties[Passport Logo]"]:checked').val() != '' && $('input[name="properties[Passport Logo]"]:checked').length) ? $('input[name="properties[Passport Logo]"]:checked').val() : '';
      var laptop_image = ($('.cl-po--upload').find('[name="properties[Laptop Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Laptop Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Laptop Image]"]').val() : '';
      var laptop_image_character = ($('.cl-po--option').find('[name="properties[Laptop Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Laptop Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Laptop Image Character]"]').val() : '';
      var laptop_logo = ($('input[name="properties[Laptop Logo]"]:checked').val() != '' && $('input[name="properties[Laptop Logo]"]:checked').length) ? $('input[name="properties[Laptop Logo]"]:checked').val() : '';
      var lady_pouch_image = ($('.cl-po--upload').find('[name="properties[Lady Pouch Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Lady Pouch Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Lady Pouch Image]"]').val() : '';
      var lady_pouch_image_character = ($('.cl-po--option').find('[name="properties[Lady Pouch Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Lady Pouch Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Lady Pouch Image Character]"]').val() : '';
      var lady_pouch_logo = ($('input[name="properties[Lady Pouch Logo]"]:checked').val() != '' && $('input[name="properties[Lady Pouch Logo]"]:checked').length) ? $('input[name="properties[Lady Pouch Logo]"]:checked').val() : '';
      var men_pouch_image = ($('.cl-po--upload').find('[name="properties[Men Pouch Image]"]').val() != '' && $('.cl-po--upload').find('[name="properties[Men Pouch Image]"]').length) ? $('.cl-po--upload').find('[name="properties[Men Pouch Image]"]').val() : '';
      var men_pouch_image_character = ($('.cl-po--option').find('[name="properties[Men Pouch Image Character]"]').val() != '' && $('.cl-po--option').find('[name="properties[Men Pouch Image Character]"]').length ) ? $('.cl-po--option').find('[name="properties[Men Pouch Image Character]"]').val() : '';
      var men_pouch_logo = ($('input[name="properties[Men Pouch Logo]"]:checked').val() != '' && $('input[name="properties[Men Pouch Logo]"]:checked').length) ? $('input[name="properties[Men Pouch Logo]"]:checked').val() : '';

      // Reusable function for combined text logic
      function getCombinedCustomText($container, mainName, extraName) {
        const main = $container.find(`[name="properties[${mainName}]"]`).val()?.trim() || '';
        const extra = $container.find(`[name="properties[${extraName}]"]`).val()?.trim() || '';

        if (main && extra) return [main, extra];
        if (main || extra) return main || extra;
        return '';
      }

      const options = $('.cl-po--option');

      // Get individual values for Shopify properties
      const cardholderText = options.find('[name="properties[Cardholder Custom Text]"]').val()?.trim() || '';
      const cardholderExtraText = options.find('[name="properties[Cardholder Extra Custom Text]"]').val()?.trim() || '';
      const lanyardText = options.find('[name="properties[Lanyard Custom Text]"]').val()?.trim() || '';
      const lanyardExtraText = options.find('[name="properties[Lanyard Extra Custom Text]"]').val()?.trim() || '';
      const passportText = options.find('[name="properties[Passport Custom Text]"]').val()?.trim() || '';
      const passportExtraText = options.find('[name="properties[Passport Extra Custom Text]"]').val()?.trim() || '';
      const walletText = options.find('[name="properties[Wallet Custom Text]"]').val()?.trim() || '';
      const walletExtraText = options.find('[name="properties[Wallet Extra Custom Text]"]').val()?.trim() || '';
      const laptopText = options.find('[name="properties[Laptop Custom Text]"]').val()?.trim() || '';
      const laptopExtraText = options.find('[name="properties[Laptop Extra Custom Text]"]').val()?.trim() || '';
      const ladyPouchText = options.find('[name="properties[Lady Pouch Custom Text]"]').val()?.trim() || '';
      const ladyPouchExtraText = options.find('[name="properties[Lady Pouch Extra Custom Text]"]').val()?.trim() || '';
      const menPouchText = options.find('[name="properties[Men Pouch Custom Text]"]').val()?.trim() || '';
      const menPouchExtraText = options.find('[name="properties[Men Pouch Extra Custom Text]"]').val()?.trim() || '';
      const iphoneText = options.find('[name="properties[iPhone Custom Text]"]').val()?.trim() || '';
      const iphoneExtraText = options.find('[name="properties[iPhone Extra Custom Text]"]').val()?.trim() || '';

      // Get combined values (for UI display, conditions, etc.)
      const cardholder_custom_text = getCombinedCustomText(options, 'Cardholder Custom Text', 'Cardholder Extra Custom Text');
      const lanyard_custom_text = getCombinedCustomText(options, 'Lanyard Custom Text', 'Lanyard Extra Custom Text');
      const passport_custom_text = getCombinedCustomText(options, 'Passport Custom Text', 'Passport Extra Custom Text');
      const wallet_custom_text = getCombinedCustomText(options, 'Wallet Custom Text', 'Wallet Extra Custom Text');
      const laptop_custom_text = getCombinedCustomText(options, 'Laptop Custom Text', 'Laptop Extra Custom Text');
      const lady_pouch_custom_text = getCombinedCustomText(options, 'Lady Pouch Custom Text', 'Lady Pouch Extra Custom Text');
      const men_pouch_custom_text = getCombinedCustomText(options, 'Men Pouch Custom Text', 'Men Pouch Extra Custom Text');
      const iphone_custom_text = getCombinedCustomText(options, 'iPhone Custom Text', 'iPhone Extra Custom Text');

      // printing text
      var personalization_type = ($('.cl-po--option').find('input[name="properties[personalization_type]"]:checked').val() != '' && $('.cl-po--option').find('input[name="properties[personalization_type]"]:checked').length ) ? $('.cl-po--option').find('input[name="properties[personalization_type]"]:checked').val() : '';
      console.log(personalization_type, "personalization_type----");
      
      var hasEngrave = 0;
      var hasImage = 0;
      var hasLogo = 0;
      var hasCustomText = 0;
      var hasCharacter = 0;
      var noOfCharacter = 0;
      var hasPrinting = 0;

      //TODO: more checks for all products logo and image except watch and airpods
      // Painting and printing

      if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0 && personalization_type === "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      //changed from engrave to custom text
      else if (iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != '' && iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if (iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != '' && iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && personalization_type === "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && personalization_type === "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if(iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if(iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != '' && personalization_type === "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if (iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0 && personalization_type === "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      
      //changed from engrave to custom text
      else if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != '' && iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0){
        hasCustomText = 1;
        hasLogo = 1;
      }
      //changed from engrave to custom text
      else if (iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != '' && iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != ''){
        hasCustomText = 1;
        hasImage = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if (iphone_engrave_text.length > 0 && iphone_engrave_text != 'undefined' && iphone_engrave_text != ''){
        hasEngrave = 1;
      }
      else if (iphone_custom_text.length > 0 && iphone_custom_text != 'undefined' && iphone_custom_text != ''){
        hasCustomText = 1;
      }
      else if(iphone_image.length > 0 && iphone_image != 'undefined' && iphone_image != ''){
        hasImage = 1;
        if(iphone_image_character.length > 0 && iphone_image_character != 'undefined' && iphone_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(iphone_image_character);
        }
      }
      else if (iphone_logo.length > 0 && iphone_logo != 'undefined' && iphone_logo != '' && iphone_logo != '0' && iphone_logo != 0){
        hasLogo = 1;
      }

      
      //changed from engrave to custom text
      else if(cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && cardholder_image.length > 0 && cardholder_image != 'undefined' && cardholder_image != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(cardholder_image_character.length > 0 && cardholder_image_character != 'undefined' && cardholder_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(cardholder_image_character);
        }
      }
      else if(cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && cardholder_image.length > 0 && cardholder_image != 'undefined' && cardholder_image != '' && personalization_type === "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(cardholder_image_character.length > 0 && cardholder_image_character != 'undefined' && cardholder_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(cardholder_image_character);
        }
      }
      //changed from engrave to custom text
      else if (cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && cardholder_logo.length > 0 && cardholder_logo != 'undefined' && cardholder_logo != '' && cardholder_logo != '0' && cardholder_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if (cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && cardholder_logo.length > 0 && cardholder_logo != 'undefined' && cardholder_logo != '' && cardholder_logo != '0' && cardholder_logo != 0 && personalization_type === "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if(cardholder_image.length > 0 && cardholder_image != 'undefined' && cardholder_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(cardholder_image_character.length > 0 && cardholder_image_character != 'undefined' && cardholder_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(cardholder_image_character);
        }
      }
      else if(cardholder_image.length > 0 && cardholder_image != 'undefined' && cardholder_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(cardholder_image_character.length > 0 && cardholder_image_character != 'undefined' && cardholder_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(cardholder_image_character);
        }
      }
      else if(cardholder_engrave_text.length > 0 && cardholder_engrave_text != 'undefined' && cardholder_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if(cardholder_custom_text.length > 0 && cardholder_custom_text != 'undefined' && cardholder_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if (cardholder_logo.length > 0 && cardholder_logo != 'undefined' && cardholder_logo != '' && cardholder_logo != '0' && cardholder_logo != 0 && personalization_type === "Painting"){
        hasLogo = 1;
      }
      else if (cardholder_logo.length > 0 && cardholder_logo != 'undefined' && cardholder_logo != '' && cardholder_logo != '0' && cardholder_logo != 0  && personalization_type === "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if(airpods_engrave_text.length > 0 && airpods_engrave_text != 'undefined' && airpods_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(airpods_custom_text.length > 0 && airpods_custom_text != 'undefined' && airpods_custom_text != ''){
        hasCustomText = 1;
      }
      else if(watch_engrave_text.length > 0 && watch_engrave_text != 'undefined' && watch_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(watch_custom_text.length > 0 && watch_custom_text != 'undefined' && watch_custom_text != ''){
        hasCustomText = 1;
      }
      //changed from engrave to custom text
      else if (lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && lanyard_logo.length > 0 && lanyard_logo != 'undefined' && lanyard_logo != '' && lanyard_logo != '0' && lanyard_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if (lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && lanyard_logo.length > 0 && lanyard_logo != 'undefined' && lanyard_logo != '' && lanyard_logo != '0' && lanyard_logo != 0 && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      //changed from engrave to custom text
      else if (lanyard_image.length > 0 && lanyard_image != 'undefined' && lanyard_image != '' && lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(lanyard_image_character.length > 0 && lanyard_image_character != 'undefined' && lanyard_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lanyard_image_character);
        }
      }
      else if (lanyard_image.length > 0 && lanyard_image != 'undefined' && lanyard_image != '' && lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(lanyard_image_character.length > 0 && lanyard_image_character != 'undefined' && lanyard_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lanyard_image_character);
        }
      }
      else if (lanyard_logo.length > 0 && lanyard_logo != 'undefined' && lanyard_logo != '' && lanyard_logo != '0' && lanyard_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (lanyard_logo.length > 0 && lanyard_logo != 'undefined' && lanyard_logo != '' && lanyard_logo != '0' && lanyard_logo != 0 && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if (lanyard_image.length > 0 && lanyard_image != 'undefined' && lanyard_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(lanyard_image_character.length > 0 && lanyard_image_character != 'undefined' && lanyard_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lanyard_image_character);
        }
      }
      else if (lanyard_image.length > 0 && lanyard_image != 'undefined' && lanyard_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(lanyard_image_character.length > 0 && lanyard_image_character != 'undefined' && lanyard_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lanyard_image_character);
        }
      }
      else if(lanyard_engrave_text.length > 0 && lanyard_engrave_text != 'undefined' && lanyard_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if(lanyard_custom_text.length > 0 && lanyard_custom_text != 'undefined' && lanyard_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      //changed from engrave to custom text
      else if (wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != '' && wallet_logo.length > 0 && wallet_logo != 'undefined' && wallet_logo != '' && wallet_logo != '0' && wallet_logo != 0  && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if (wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != '' && wallet_logo.length > 0 && wallet_logo != 'undefined' && wallet_logo != '' && wallet_logo != '0' && wallet_logo != 0  && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      //changed from engrave to custom text
      else if(wallet_image.length > 0 && wallet_image != 'undefined' && wallet_image != '' && wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(wallet_image_character.length > 0 && wallet_image_character != 'undefined' && wallet_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(wallet_image_character);
        }
      }
      else if(wallet_image.length > 0 && wallet_image != 'undefined' && wallet_image != '' && wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != ''  && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(wallet_image_character.length > 0 && wallet_image_character != 'undefined' && wallet_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(wallet_image_character);
        }
      }
      else if(wallet_engrave_text.length > 0 && wallet_engrave_text != 'undefined' && wallet_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if(wallet_custom_text.length > 0 && wallet_custom_text != 'undefined' && wallet_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if (wallet_logo.length > 0 && wallet_logo != 'undefined' && wallet_logo != '' && wallet_logo != '0' && wallet_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (wallet_logo.length > 0 && wallet_logo != 'undefined' && wallet_logo != '' && wallet_logo != '0' && wallet_logo != 0 && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if(wallet_image.length > 0 && wallet_image != 'undefined' && wallet_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(wallet_image_character.length > 0 && wallet_image_character != 'undefined' && wallet_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(wallet_image_character);
        }
      }
      else if(wallet_image.length > 0 && wallet_image != 'undefined' && wallet_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(wallet_image_character.length > 0 && wallet_image_character != 'undefined' && wallet_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(wallet_image_character);
        }
      }
      //changed from engrave to custom text
      else if(passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && passport_logo.length > 0 && passport_logo != 'undefined' && passport_logo != '' && passport_logo != '0' && passport_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if(passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && passport_logo.length > 0 && passport_logo != 'undefined' && passport_logo != '' && passport_logo != '0' && passport_logo != 0 && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      //changed from engrave to custom text
      else if(passport_image.length > 0 && passport_image != 'undefined' && passport_image != '' && passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(passport_image_character.length > 0 && passport_image_character != 'undefined' && passport_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(passport_image_character);
        }
      }
      else if(passport_image.length > 0 && passport_image != 'undefined' && passport_image != '' && passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(passport_image_character.length > 0 && passport_image_character != 'undefined' && passport_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(passport_image_character);
        }
      }
      else if (passport_engrave_text.length > 0 && passport_engrave_text != 'undefined' && passport_engrave_text != ''){
        hasEngrave = 1;
      }
      else if (passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if (passport_custom_text.length > 0 && passport_custom_text != 'undefined' && passport_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if (passport_logo.length > 0 && passport_logo != 'undefined' && passport_logo != '' && passport_logo != '0' && passport_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (passport_logo.length > 0 && passport_logo != 'undefined' && passport_logo != '' && passport_logo != '0' && passport_logo != 0 && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if (passport_image.length > 0 && passport_image != 'undefined' && passport_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(passport_image_character.length > 0 && passport_image_character != 'undefined' && passport_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(passport_image_character);
        }
      }
      else if (passport_image.length > 0 && passport_image != 'undefined' && passport_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(passport_image_character.length > 0 && passport_image_character != 'undefined' && passport_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(passport_image_character);
        }
      }
      else if(keychain_engrave_text.length > 0 && keychain_engrave_text != 'undefined' && keychain_engrave_text != ''){
        hasEngrave = 1;
      }
      else if(keychain_custom_text.length > 0 && keychain_custom_text != 'undefined' && keychain_custom_text != ''){
        hasCustomText = 1;
      }

      //changed from engrave to custom text laptop sleeve
      else if  (laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && laptop_logo.length > 0 && laptop_logo != 'undefined' && laptop_logo != '' && laptop_logo != '0' && laptop_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if  (laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && laptop_logo.length > 0 && laptop_logo != 'undefined' && laptop_logo != '' && laptop_logo != '0' && laptop_logo != 0 && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if (laptop_image.length > 0 && laptop_image != 'undefined' && laptop_image != '' && laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(laptop_image_character.length > 0 && laptop_image_character != 'undefined' && laptop_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(laptop_image_character);
        }
      }
      else if (laptop_image.length > 0 && laptop_image != 'undefined' && laptop_image != '' && laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(laptop_image_character.length > 0 && laptop_image_character != 'undefined' && laptop_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(laptop_image_character);
        }
      }
      else if (laptop_engrave_text.length > 0 && laptop_engrave_text != 'undefined' && laptop_engrave_text != ''){
        hasEngrave = 1;
      }
      else if (laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if (laptop_custom_text.length > 0 && laptop_custom_text != 'undefined' && laptop_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if(laptop_image.length > 0 && laptop_image != 'undefined' && laptop_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(laptop_image_character.length > 0 && laptop_image_character != 'undefined' && laptop_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(laptop_image_character);
        }
      }
      else if(laptop_image.length > 0 && laptop_image != 'undefined' && laptop_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(laptop_image_character.length > 0 && laptop_image_character != 'undefined' && laptop_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(laptop_image_character);
        }
      }
      else if (laptop_logo.length > 0 && laptop_logo != 'undefined' && laptop_logo != '' && laptop_logo != '0' && laptop_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (laptop_logo.length > 0 && laptop_logo != 'undefined' && laptop_logo != '' && laptop_logo != '0' && laptop_logo != 0 && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }

      //changed from engrave to custom text of pouch
      else if  (lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && lady_pouch_logo.length > 0 && lady_pouch_logo != 'undefined' && lady_pouch_logo != '' && lady_pouch_logo != '0' && lady_pouch_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if  (lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && lady_pouch_logo.length > 0 && lady_pouch_logo != 'undefined' && lady_pouch_logo != '' && lady_pouch_logo != '0' && lady_pouch_logo != 0 && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if (lady_pouch_image.length > 0 && lady_pouch_image != 'undefined' && lady_pouch_image != '' && lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(lady_pouch_image_character.length > 0 && lady_pouch_image_character != 'undefined' && lady_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lady_pouch_image_character);
        }
      }
      else if (lady_pouch_image.length > 0 && lady_pouch_image != 'undefined' && lady_pouch_image != '' && lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(lady_pouch_image_character.length > 0 && lady_pouch_image_character != 'undefined' && lady_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lady_pouch_image_character);
        }
      }
      else if (lady_pouch_engrave_text.length > 0 && lady_pouch_engrave_text != 'undefined' && lady_pouch_engrave_text != ''){
        hasEngrave = 1;
      }
      else if (lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if (lady_pouch_custom_text.length > 0 && lady_pouch_custom_text != 'undefined' && lady_pouch_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if(lady_pouch_image.length > 0 && lady_pouch_image != 'undefined' && lady_pouch_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(lady_pouch_image_character.length > 0 && lady_pouch_image_character != 'undefined' && lady_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lady_pouch_image_character);
        }
      }
      else if(lady_pouch_image.length > 0 && lady_pouch_image != 'undefined' && lady_pouch_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(lady_pouch_image_character.length > 0 && lady_pouch_image_character != 'undefined' && lady_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(lady_pouch_image_character);
        }
      }
      else if (lady_pouch_logo.length > 0 && lady_pouch_logo != 'undefined' && lady_pouch_logo != '' && lady_pouch_logo != '0' && lady_pouch_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (lady_pouch_logo.length > 0 && lady_pouch_logo != 'undefined' && lady_pouch_logo != '' && lady_pouch_logo != '0' && lady_pouch_logo != 0 && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }

      //changed from engrave to custom text of men pouch
      else if  (men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && men_pouch_logo.length > 0 && men_pouch_logo != 'undefined' && men_pouch_logo != '' && men_pouch_logo != '0' && men_pouch_logo != 0 && personalization_type == "Painting"){
        hasCustomText = 1;
        hasLogo = 1;
      }
      else if  (men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && men_pouch_logo.length > 0 && men_pouch_logo != 'undefined' && men_pouch_logo != '' && men_pouch_logo != '0' && men_pouch_logo != 0 && personalization_type == "Printing"){
        hasCustomText = 1;
        hasLogo = 1;
        hasPrinting = 1;
      }
      else if (men_pouch_image.length > 0 && men_pouch_image != 'undefined' && men_pouch_image != '' && men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
        hasImage = 1;
        if(men_pouch_image_character.length > 0 && men_pouch_image_character != 'undefined' && men_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(men_pouch_image_character);
        }
      }
      else if (men_pouch_image.length > 0 && men_pouch_image != 'undefined' && men_pouch_image != '' && men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasImage = 1;
        hasPrinting = 1;
        if(men_pouch_image_character.length > 0 && men_pouch_image_character != 'undefined' && men_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(men_pouch_image_character);
        }
      }
      else if (men_pouch_engrave_text.length > 0 && men_pouch_engrave_text != 'undefined' && men_pouch_engrave_text != ''){
        hasEngrave = 1;
      }
      else if (men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && personalization_type == "Painting"){
        hasCustomText = 1;
      }
      else if (men_pouch_custom_text.length > 0 && men_pouch_custom_text != 'undefined' && men_pouch_custom_text != '' && personalization_type == "Printing"){
        hasCustomText = 1;
        hasPrinting = 1;
      }
      else if(men_pouch_image.length > 0 && men_pouch_image != 'undefined' && men_pouch_image != '' && personalization_type == "Painting"){
        hasImage = 1;
        if(men_pouch_image_character.length > 0 && men_pouch_image_character != 'undefined' && men_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(men_pouch_image_character);
        }
      }
      else if(men_pouch_image.length > 0 && men_pouch_image != 'undefined' && men_pouch_image != '' && personalization_type == "Printing"){
        hasImage = 1;
        hasPrinting = 1;
        if(men_pouch_image_character.length > 0 && men_pouch_image_character != 'undefined' && men_pouch_image_character != ''){
          hasCharacter = 1;
          noOfCharacter = parseInt(men_pouch_image_character);
        }
      }
      else if (men_pouch_logo.length > 0 && men_pouch_logo != 'undefined' && men_pouch_logo != '' && men_pouch_logo != '0' && men_pouch_logo != 0 && personalization_type == "Painting"){
        hasLogo = 1;
      }
      else if (men_pouch_logo.length > 0 && men_pouch_logo != 'undefined' && men_pouch_logo != '' && men_pouch_logo != '0' && men_pouch_logo != 0  && personalization_type == "Printing"){
        hasLogo = 1;
        hasPrinting = 1;
      }
      
      console.log('hasEngrave: ' + hasEngrave);
      console.log('hasImage: ' + hasImage);
      console.log('hasLogo: ' + hasLogo);
      console.log('hasCustomText: ' + hasCustomText);
      console.log('hasCharacter: ' + hasCharacter);
      console.log('noOfCharacter: ' + noOfCharacter);
      console.log('hasPrinting: ' + hasPrinting);
      
      var actual_pro = $("select.t4s-product__select option:selected").val();
      var engrave_text_charge = '39605537701934';
      var custom_text_charge = '40202142482478';
      var image_charge = '40202142875694';
      var logo_charge = '40203015389230';
      var custom_text_image_charge = '40202143039534';
      var custom_text_logo_charge = '40203015520302';
      //var engrave_text_image_charge = '40202143039534';
      //var engrave_text_logo_charge = '40203015520302';
      //var engrave_limit = {{settings.extra_charge}};
      if(actual_pro == undefined || actual_pro == '' || actual_pro == null){
        actual_pro = $('input[name="id"]').val();
      }

      if(hasCustomText && hasImage && hasPrinting || hasCustomText && hasImage){
        console.log('i have custom text and image with '+noOfCharacter+' character');

        let addQuantity = 1;

        if (hasCharacter && noOfCharacter == 1) {
            if (hasPrinting) {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '41346222293038';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289101870';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289101870';
                } else {
                    custom_text_image_charge = '41346070446126';
                }
            } else {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '40830433165358';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107683082286';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107683082286';
                } else {
                    custom_text_image_charge = '40202143039534';
                }
            }
        } else if (hasCharacter && noOfCharacter == 2) {
            if (hasPrinting) {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '41346222456878';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289134638';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289134638';
                } else {
                    custom_text_image_charge = '41346070478894';
                }
            } else {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '40830433198126';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107683573806';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107683573806';
                } else {
                    custom_text_image_charge = '40306740068398';
                }
            }
        } else if (hasCharacter && noOfCharacter == 3) {
            if (hasPrinting) {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '41346222587950';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289495086';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41348289495086';
                } else {
                    custom_text_image_charge = '41346070511662';
                }
            } else {
                if (laptop_custom_text.length > 0 && laptop_image.length > 0 && laptop_image_character.length > 0) {
                    custom_text_image_charge = '40830433230894';
                } else if (men_pouch_custom_text.length > 0 && men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107684163630';
                } else if (lady_pouch_custom_text.length > 0 && lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                    custom_text_image_charge = '41107684163630';
                } else {
                    custom_text_image_charge = '40306740101166';
                }
            }
        }

        const customTextProperties = {
          "Actual Product": actual_pro,
          "iPhone Custom Text": iphoneText,
          "Laptop Custom Text": laptopText,
          "Lady Pouch Custom Text": ladyPouchText,
          "Men Pouch Custom Text": menPouchText,
          "Cardholder Custom Text": cardholderText,
          "Wallet Custom Text": walletText,
          "Lanyard Custom Text": lanyardText,
          "Passport Custom Text": passportText,
          "Airpods Custom Text": airpods_custom_text,
          "Watch Custom Text": watch_custom_text,
          "Keychain Custom Text": keychain_custom_text,
        
          "iPhone Image": iphone_image,
          "iPhone Image Character": iphone_image_character,
          "Laptop Image": laptop_image,
          "Laptop Image Character": laptop_image_character,
          "Lady Pouch Image Character": lady_pouch_image_character,
          "Lady Pouch Image": lady_pouch_image,
          "Men Pouch Image Character": men_pouch_image_character,
          "Men Pouch Image": men_pouch_image,
          "Cardholder Image": cardholder_image,
          "Cardholder Image Character": cardholder_image_character,
          "Wallet Image": wallet_image,
          "Wallet Image Character": wallet_image_character,
          "Lanyard Image": lanyard_image,
          "Lanyard Image Character": lanyard_image_character,
          "Passport Image": passport_image,
          "Passport Image Character": passport_image_character
        };

        let default_extra_variant_id = '41466404438062';
        let laptop_extra_variant_id = '40830433034286';
        let pouch_extra_variant_id = '41107641237550';
        let postData = [
          {
            id: custom_text_image_charge,
            quantity: addQuantity,
            // sections: sections_nt,
            // sections_url: window.location.pathname,
            properties: customTextProperties
          }
        ];
      
        function addExtraLineItemIfNeeded(condition, extraText, label, variantOverride = null) {
          if (Array.isArray(condition) && condition.length === 2) {
            postData.push({
              id: variantOverride || default_extra_variant_id,
              quantity: addQuantity,
              // sections: sections_nt,
              // sections_url: window.location.pathname,
              properties: {
                "Actual Product": actual_pro,
                [label]: extraText
              }
            });
          }
        }


        // Usage
        addExtraLineItemIfNeeded(iphone_custom_text, iphoneExtraText, 'iPhone Extra Custom Text');
        addExtraLineItemIfNeeded(cardholder_custom_text, cardholderExtraText, 'Cardholder Extra Custom Text');
        addExtraLineItemIfNeeded(lanyard_custom_text, lanyardExtraText, 'Lanyard Extra Custom Text');
        addExtraLineItemIfNeeded(passport_custom_text, passportExtraText, 'Passport Extra Custom Text');
        addExtraLineItemIfNeeded(wallet_custom_text, walletExtraText, 'Wallet Extra Custom Text');
        // addExtraLineItemIfNeeded(laptop_custom_text, laptopExtraText, 'Laptop Extra Custom Text', laptop_extra_variant_id);
        // addExtraLineItemIfNeeded(lady_pouch_custom_text, ladyPouchExtraText, 'Lady Pouch Extra Custom Text', pouch_extra_variant_id);
        // addExtraLineItemIfNeeded(men_pouch_custom_text, menPouchExtraText, 'Men Pouch Extra Custom Text', pouch_extra_variant_id);

        addExtraLineItemIfNeeded(
          laptop_custom_text,
          laptopExtraText,
          'Laptop Extra Custom Text',
          hasPrinting === 0 ? laptop_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          lady_pouch_custom_text,
          ladyPouchExtraText,
          'Lady Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          men_pouch_custom_text,
          menPouchExtraText,
          'Men Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );


        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            data: { items: postData, sections: sections_nt, sections_url: window.location.pathname },
            success: function(result){
              $("p.cart-error").remove();
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
            }
          });
        }, 1250);
        // async function addToCart(postData) {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ items: postData, sections: sections_nt, sections_url: window.location.pathname })
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }
            
        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart(postData);

      }
      else if(hasCustomText && hasLogo){
        console.log('i have custom text and logo');

        let addQuantity = 1;

        if (laptop_logo.length > 0 && hasPrinting) {
            custom_text_logo_charge = '41346222260270';
        } else if ((men_pouch_logo.length > 0 || lady_pouch_logo.length > 0) && hasPrinting) {
            custom_text_logo_charge = '41348288806958';
        } else if (laptop_logo.length > 0) {
            custom_text_logo_charge = '40830433296430';
        } else if (men_pouch_logo.length > 0 || lady_pouch_logo.length > 0) {
            custom_text_logo_charge = '41107801014318';
        } else if (hasPrinting) {
            custom_text_logo_charge = '41346065694766';
        } else {
          custom_text_logo_charge = custom_text_logo_charge;
        }

        let customProperties = {
          "Actual Product": actual_pro,
          "iPhone Custom Text": iphoneText,
          "Laptop Custom Text": laptopText,
          "Lady Pouch Custom Text": ladyPouchText,
          "Men Pouch Custom Text": menPouchText,
          "Cardholder Custom Text": cardholderText,
          "Wallet Custom Text": walletText,
          "Lanyard Custom Text": lanyardText,
          "Passport Custom Text": passportText,
          "Airpods Custom Text": airpods_custom_text,
          "Watch Custom Text": watch_custom_text,
          "Keychain Custom Text": keychain_custom_text,
          "iPhone Logo": iphone_logo,
          "Laptop Logo": laptop_logo,
          "Lady Pouch Logo": lady_pouch_logo,
          "Men Pouch Logo": men_pouch_logo,
          "Lanyard Logo": lanyard_logo,
          "Cardholder Logo": cardholder_logo,
          "Wallet Logo": wallet_logo,
          "Passport Logo": passport_logo
        };

        let default_extra_variant_id = '41466404438062';
        let laptop_extra_variant_id = '40830433034286';
        let pouch_extra_variant_id = '41107641237550';
        let postData = [
          {
            id: custom_text_logo_charge,
            quantity: addQuantity,
            // sections: sections_nt,
            // sections_url: window.location.pathname,
            properties: customProperties
          }
        ];
      
        function addExtraLineItemIfNeeded(condition, extraText, label, variantOverride = null) {
          if (Array.isArray(condition) && condition.length === 2) {
            postData.push({
              id: variantOverride || default_extra_variant_id,
              quantity: addQuantity,
              // sections: sections_nt,
              // sections_url: window.location.pathname,
              properties: {
                "Actual Product": actual_pro,
                [label]: extraText
              }
            });
          }
        }

        // Usage
        addExtraLineItemIfNeeded(iphone_custom_text, iphoneExtraText, 'iPhone Extra Custom Text');
        addExtraLineItemIfNeeded(cardholder_custom_text, cardholderExtraText, 'Cardholder Extra Custom Text');
        addExtraLineItemIfNeeded(lanyard_custom_text, lanyardExtraText, 'Lanyard Extra Custom Text');
        addExtraLineItemIfNeeded(passport_custom_text, passportExtraText, 'Passport Extra Custom Text');
        addExtraLineItemIfNeeded(wallet_custom_text, walletExtraText, 'Wallet Extra Custom Text');
        // addExtraLineItemIfNeeded(laptop_custom_text, laptopExtraText, 'Laptop Extra Custom Text', laptop_extra_variant_id);
        // addExtraLineItemIfNeeded(lady_pouch_custom_text, ladyPouchExtraText, 'Lady Pouch Extra Custom Text', pouch_extra_variant_id);
        // addExtraLineItemIfNeeded(men_pouch_custom_text, menPouchExtraText, 'Men Pouch Extra Custom Text', pouch_extra_variant_id);

        addExtraLineItemIfNeeded(
          laptop_custom_text,
          laptopExtraText,
          'Laptop Extra Custom Text',
          hasPrinting === 0 ? laptop_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          lady_pouch_custom_text,
          ladyPouchExtraText,
          'Lady Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          men_pouch_custom_text,
          menPouchExtraText,
          'Men Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );

        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            data: { items: postData, sections: sections_nt, sections_url: window.location.pathname },
            success: function(result){
              $("p.cart-error").remove();
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
            }
          });
        }, 1250);
        // async function addToCart(postData) {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ items: postData, sections: sections_nt, sections_url: window.location.pathname })
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }

        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart(postData);

      }
      else if(hasEngrave && !hasImage || hasEngrave && !hasLogo){
        console.log("i have engraved text only");
        if(laptop_engrave_text.length > 0){
          engrave_text_charge = '40830433001518'
        } else if(men_pouch_engrave_text.length > 0 || lady_pouch_engrave_text.length > 0 ) {
          engrave_text_charge = '41107638517806'
        } 
        let addQuantity = 1
        
        if (Array.isArray(iphone_engrave_text) && iphone_engrave_text.length > 1) {
          addQuantity = iphone_engrave_text.length;
        } 
        else if (Array.isArray(lanyard_engrave_text) && lanyard_engrave_text.length > 1) {
          addQuantity = lanyard_engrave_text.length;
        } 
        else if (Array.isArray(wallet_engrave_text) && wallet_engrave_text.length > 1) {
          addQuantity = wallet_engrave_text.length;
        } 
        else if (Array.isArray(passport_engrave_text) && passport_engrave_text.length > 1) {
          addQuantity = passport_engrave_text.length;
        } else {
          addQuantity = 1;
        }

        let properties = {
          "Actual Product": actual_pro,
          "iPhone Engrave Top" : engraveTop,
          "iPhone Engrave Top Right": iphone_engrave_top_right,
          "iPhone Engrave Top Left": iphone_engrave_top_left,
          "iPhone Engrave Center Left": iphone_engrave_center_left,
          "iPhone Engrave Bottom Left": iphone_engrave_bottom_left,
          "iPhone Engrave Bottom Right": iphone_engrave_bottom_right,
          "iPhone Engrave": engraveMain,
          "iPhone Engrave Center": iphone_engrave_center,
          "iPhone Engrave Bottom": iphone_engrave_bottom,
          "Laptop Engrave": laptop_engrave_text,
          "Lady Pouch Engrave": lady_pouch_engrave_text,
          "Men Pouch Engrave": men_pouch_engrave_text,
          "Cardholder Engrave": cardholder_engrave_text,
          "Wallet Engrave": wallet_inside,
          "Wallet Engrave Top": wallet_top,
          "Wallet Engrave Center": wallet_center,
          "Wallet Engrave Bottom": wallet_bottom,
          "Lanyard Engrave Center": main,
          "Lanyard Engrave Top": top,
          "Lanyard Engrave Bottom": bottom,
          "Passport Engrave": passport_inside,
          "Passport Engrave Top": passport_top,
          "Passport Engrave Center": passport_center,
          "Passport Engrave Bottom": passport_bottom,
          "Airpods Engrave": airpods_engrave_text,
          "Watch Engrave": watch_engrave_text,
          "Keychain Engrave": keychain_engrave_text
        };
        console.log(iphone_engrave_text,"iphone_engrave_text");
        
        // Only include "iPhone Engrave" if it's NOT an array
        if (!Array.isArray(iphone_engrave_text) && !engraveMain) {
          properties["iPhone Engrave Top"] = iphone_engrave_text;
        }

        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            data: {"id": engrave_text_charge, "quantity": addQuantity, "sections":sections_nt, "sections_url":window.location.pathname, "properties": properties},
            success: function(result){
              $("p.cart-error").remove();
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
            }
          });
        }, 1250);
        // async function addToCart() {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ "id": engrave_text_charge, "quantity": addQuantity, "sections":sections_nt, "sections_url":window.location.pathname, "properties": properties})
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }

        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart();

      }
      else if(hasCustomText && !hasImage || hasCustomText && !hasLogo){
        console.log("i have custom text only");
        
        
        if (laptop_custom_text.length > 0 && hasPrinting) {
            custom_text_charge = '41346219999278';
        } else if ((men_pouch_custom_text.length > 0 || lady_pouch_custom_text.length > 0) && hasPrinting) {
            custom_text_charge = '41348288184366';
        } else if (laptop_custom_text.length > 0) {
            custom_text_charge = '40830433034286';
        } else if (men_pouch_custom_text.length > 0 || lady_pouch_custom_text.length > 0) {
            custom_text_charge = '41107641237550';
        } else if (hasPrinting) {
            custom_text_charge = '41346028929070';
        } else if (personalization_type == "" || personalization_type == null) {
          custom_text_charge = '41346028929070';
        }

        let addQuantity = 1

        let customTextProperties = {
          "Actual Product": actual_pro,
          "iPhone Custom Text": iphoneText,
          "Laptop Custom Text": laptopText,
          "Lady Pouch Custom Text": ladyPouchText,
          "Men Pouch Custom Text": menPouchText,
          "Cardholder Custom Text": cardholderText,
          "Wallet Custom Text": walletText,
          "Lanyard Custom Text": lanyardText,
          "Passport Custom Text": passportText,
          "Airpods Custom Text": airpods_custom_text,
          "Watch Custom Text": watch_custom_text,
          "Keychain Custom Text": keychain_custom_text,
        };
        let default_extra_variant_id = '41466404438062';
        let laptop_extra_variant_id = '40830433034286';
        let pouch_extra_variant_id = '41107641237550';
        let postData = [
          {
            id: custom_text_charge,
            quantity: addQuantity,
            // sections: sections_nt,
            // sections_url: window.location.pathname,
            properties: customTextProperties
          }
        ];
      
        function addExtraLineItemIfNeeded(condition, extraText, label, variantOverride = null) {
          if (Array.isArray(condition) && condition.length === 2) {
            postData.push({
              id: variantOverride || default_extra_variant_id,
              quantity: addQuantity,
              // sections: sections_nt,
              // sections_url: window.location.pathname,
              properties: {
                "Actual Product": actual_pro,
                [label]: extraText,
              }
            });
          }
        }

        // Usage
        addExtraLineItemIfNeeded(iphone_custom_text, iphoneExtraText, 'iPhone Extra Custom Text');
        addExtraLineItemIfNeeded(cardholder_custom_text, cardholderExtraText, 'Cardholder Extra Custom Text');
        addExtraLineItemIfNeeded(lanyard_custom_text, lanyardExtraText, 'Lanyard Extra Custom Text');
        addExtraLineItemIfNeeded(passport_custom_text, passportExtraText, 'Passport Extra Custom Text');
        addExtraLineItemIfNeeded(wallet_custom_text, walletExtraText, 'Wallet Extra Custom Text');
        // addExtraLineItemIfNeeded(laptop_custom_text, laptopExtraText, 'Laptop Extra Custom Text', laptop_extra_variant_id);
        // addExtraLineItemIfNeeded(lady_pouch_custom_text, ladyPouchExtraText, 'Lady Pouch Extra Custom Text', pouch_extra_variant_id);
        // addExtraLineItemIfNeeded(men_pouch_custom_text, menPouchExtraText, 'Men Pouch Extra Custom Text', pouch_extra_variant_id);

        addExtraLineItemIfNeeded(
          laptop_custom_text,
          laptopExtraText,
          'Laptop Extra Custom Text',
          hasPrinting === 0 ? laptop_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          lady_pouch_custom_text,
          ladyPouchExtraText,
          'Lady Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );

        addExtraLineItemIfNeeded(
          men_pouch_custom_text,
          menPouchExtraText,
          'Men Pouch Extra Custom Text',
          hasPrinting === 0 ? pouch_extra_variant_id : null
        );

        console.log(postData, "postData-----");
        
        
        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            data: { items: postData, sections: sections_nt, sections_url: window.location.pathname},
            success: function(result){
              $("p.cart-error").remove();
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
            }
          });
        }, 1250);

        // async function addToCart(postData) {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ items: postData, sections: sections_nt, sections_url: window.location.pathname})
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }

        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart(postData);

      }
      else if(hasImage && !hasEngrave || hasImage && !hasCustomText){
        console.log("i have image only with "+noOfCharacter+" character");
        
        // Change product id as per slected character length with image

        if (hasCharacter && noOfCharacter == 1 && hasPrinting) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '41346220425262';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41348288577582';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41348288577582';
            } else {
                image_charge = '41346067267630';
            }
        } else if (hasCharacter && noOfCharacter == 2 && hasPrinting) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '41346220851246';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41348288610350';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41348288610350';
            } else {
                image_charge = '41346067497006';
            }
        } else if (hasCharacter && noOfCharacter == 3 && hasPrinting) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '41346222063662';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41348288675886';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41348288675886';
            } else {
                image_charge = '41346067529774';
            }
        } else if (hasCharacter && noOfCharacter == 1) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '40830433067054';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41107645104174';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41107645104174';
            } else {
                image_charge = '40202142875694';
            }
        } else if (hasCharacter && noOfCharacter == 2) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '40830433099822';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41107645825070';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41107645825070';
            } else {
                image_charge = '40306740002862';
            }
        } else if (hasCharacter && noOfCharacter == 3) {
            if (laptop_image.length > 0 && laptop_image_character.length > 0) {
                image_charge = '40830433132590';
            } else if (men_pouch_image.length > 0 && men_pouch_image_character.length > 0) {
                image_charge = '41107651723310';
            } else if (lady_pouch_image.length > 0 && lady_pouch_image_character.length > 0) {
                image_charge = '41107651723310';
            } else {
                image_charge = '40306740035630';
            }
        }

         
        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            //data: {"id": add_this ,"qty": 1, "properties": {"Actual Product": actual_pro, "Engrave List": pr_text, "Iphone Image": pr_image}},
            data: {"id": image_charge, "qty": 1, "sections":sections_nt, "sections_url":window.location.pathname, "properties": {"Actual Product": actual_pro, "iPhone Image": iphone_image, "iPhone Image Character": iphone_image_character, "Laptop Image": laptop_image, "Laptop Image Character": laptop_image_character, "Lady Pouch Image": lady_pouch_image, "Lady Pouch Image Character": lady_pouch_image_character,  "Men Pouch Image": men_pouch_image, "Men Pouch Image Character": men_pouch_image_character, "Cardholder Image": cardholder_image,  "Cardholder Image Character": cardholder_image_character, "Wallet Image": wallet_image, "Wallet Image Character": wallet_image_character, "Lanyard Image": lanyard_image, "Lanyard Image Character": lanyard_image_character, "Passport Image": passport_image, "Passport Image Character": passport_image_character}},
            success: function(result){
              $("p.cart-error").remove();
              //if(redirect_to_cart){
              //  document.location.href='https://iqoniq.co/cart';
              //}
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
              //var id = 40202142875694;//line_item.items[0].product_id;
              var id = parseInt(image_charge);
              //geckoShopify.onCartUpdate(1,1,id);
                    //body.trigger('CartUpdateSuccess');
            }
          });
        }, 1250);

        // async function addToCart() {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ "id": image_charge, "qty": 1, "sections":sections_nt, "sections_url":window.location.pathname, "properties": {"Actual Product": actual_pro, "iPhone Image": iphone_image, "iPhone Image Character": iphone_image_character, "Laptop Image": laptop_image, "Laptop Image Character": laptop_image_character, "Lady Pouch Image": lady_pouch_image, "Lady Pouch Image Character": lady_pouch_image_character,  "Men Pouch Image": men_pouch_image, "Men Pouch Image Character": men_pouch_image_character, "Cardholder Image": cardholder_image,  "Cardholder Image Character": cardholder_image_character, "Wallet Image": wallet_image, "Wallet Image Character": wallet_image_character, "Lanyard Image": lanyard_image, "Lanyard Image Character": lanyard_image_character, "Passport Image": passport_image, "Passport Image Character": passport_image_character} })
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }

        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart();

      }
      else if(hasLogo && !hasEngrave || hasLogo && !hasCustomText){
        console.log("i have logo only");

        if (laptop_logo.length > 0 && hasPrinting) {
          logo_charge = '41346220261422'
        } else if (laptop_logo.length > 0) {
          logo_charge = "40830433263662"
        } else if ((men_pouch_logo.length > 0 && hasPrinting) || (lady_pouch_logo.length > 0 && hasPrinting) ) {
          logo_charge = '41348288512046'
        } else if (men_pouch_logo.length > 0 || lady_pouch_logo.length > 0 ) {
          logo_charge = '41107642351662'
        } else if (hasPrinting) {
          logo_charge = '41346029551662'
        } 

        setTimeout(() => {
          $.ajax({
            type: 'POST', 
            url: '/cart/add',
            dataType: 'json', 
            //data: {"id": add_this ,"qty": 1, "properties": {"Actual Product": actual_pro, "Engrave List": pr_text, "Iphone Image": pr_image}},
            data: {"id": logo_charge, "qty": 1, "sections":sections_nt, "sections_url":window.location.pathname, "properties": {"Actual Product": actual_pro, "iPhone Logo": iphone_logo, "Laptop Logo": laptop_logo, "Lady Pouch Logo": lady_pouch_logo, "Men Pouch Logo": men_pouch_logo, "Lanyard Logo": lanyard_logo, "Cardholder Logo": cardholder_logo, "Wallet Logo": wallet_logo, "Passport Logo": passport_logo}},
            success: function(result){
              $("p.cart-error").remove();
              //if(redirect_to_cart){
              //  document.location.href='https://iqoniq.co/cart';
              //}
            },
            error: function(error){
              $("button.single_add_to_cart_button").after("<p class='cart-error'>"+error.responseJSON.description+"</p>");
            },
            complete: function(response) {
              if (response.status && response.status !== 200) {
                 handleErrorMessage(response.responseJSON.description);
                 $document.trigger('cart:updated');
                 return;
              }
              $document.trigger('add:cart:success').trigger('add:cart:upsell');
              T4SThemeSP.isATCSuccess = true;
              T4SThemeSP.Cart.renderContents(response.responseJSON.sections);
              //var id = 40203015389230;//line_item.items[0].product_id;
              //geckoShopify.onCartUpdate(1,1,id);
                    //body.trigger('CartUpdateSuccess');
            }
          });
        }, 1250);

        // async function addToCart() {
        //   try {
        //     const response = await fetch('/cart/add.js', {
        //       method: 'POST',
        //       headers: {
        //         'Content-Type': 'application/json',
        //         Accept: 'application/json'
        //       },
        //       body: JSON.stringify({ "id": logo_charge, "qty": 1, "sections":sections_nt, "sections_url":window.location.pathname, "properties": {"Actual Product": actual_pro, "iPhone Logo": iphone_logo, "Laptop Logo": laptop_logo, "Lady Pouch Logo": lady_pouch_logo, "Men Pouch Logo": men_pouch_logo, "Lanyard Logo": lanyard_logo, "Cardholder Logo": cardholder_logo, "Wallet Logo": wallet_logo, "Passport Logo": passport_logo} })
        //     });

        //     const result = await response.json();

        //     if (!response.ok) {
        //       $("button.single_add_to_cart_button").after(
        //         `<p class='cart-error'>${result?.description || 'Failed to add to cart'}</p>`
        //       );
        //       handleErrorMessage(result?.description || 'Error');
        //       $(document).trigger('cart:updated');
        //       return;
        //     }

        //     $("p.cart-error").remove();
        //     $(document).trigger('add:cart:success').trigger('add:cart:upsell');
        //     T4SThemeSP.isATCSuccess = true;
        //     T4SThemeSP.Cart.renderContents(result?.sections || {});
        //   } catch (error) {
        //     $("button.single_add_to_cart_button").after(
        //       `<p class='cart-error'>${error?.message || 'Something went wrong'}</p>`
        //     );
        //     console.error('Cart Add Error:', error);
        //   }
        // }

        // ✅ Usage
        // addToCart();

      }
    }
    //end of custom by chintan

})( jQuery_T4NT );